import { useEffect } from 'react';
import { HelpBubbleEventName } from '../../events';
/**
 * Lytter på hjelpeboble-eventer.
 *
 * @param callback Funksjon som skal kjøres når det skjer en hjelpeboble-event.
 */
export const useHelpBubbleEvent = (callback) => {
    useEffect(() => {
        const handler = (event) => {
            callback(event);
        };
        window.addEventListener(HelpBubbleEventName, handler);
        return () => {
            window.removeEventListener(HelpBubbleEventName, handler);
        };
    }, [callback]);
};
